import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import { Voicemail } from "../components/Voicemail.jsx";

const VoicemailModule = (props) => (
  <SummaryItem itemKey={"Voicemail: "}>
    <Voicemail config={props.module} />
  </SummaryItem>
);

export default VoicemailModule;

VoicemailModule.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
